import React from 'react'

import RadioOption from '../../RadioOption/RadioOption'
import Address from './Address/Address'


const AddressRadioOption = ({ name, activeOption, activeOptionLink, label, valueLink, isActive, editableFields, ariaLabelledBy }) => (
  <RadioOption
    name={name}
    activeOption={activeOption}
    activeOptionLink={activeOptionLink}
    label={label}
    isActive={isActive}
    ariaLabelledBy={ariaLabelledBy}
  >
    <Address
      valueLink={valueLink}
      name={name}
      editableFields={editableFields}
    />
  </RadioOption>
)

export default AddressRadioOption
